export const isOnMobile = (): boolean => {
  //@ts-ignore
  return window.innerWidth <= 576;
}
export const isOnTablet = (): boolean => {
  //@ts-ignore
  return window.innerWidth > 576 && window.innerWidth <= 768;
}